import React, { useRef } from "react";
import classNames from "classnames";
import { useField, FieldHookConfig } from "formik";
import ClipLoader from "react-spinners/ClipLoader";
import { FaCaretDown } from "react-icons/fa";
import "./style.scss";

type Props = FieldHookConfig<string> & {
  values?: {
    title: string;
    id: any;
  }[];
  label?: string;
  className?: string;
  placeholder?: string;
  help?: string;
  isRequired?: boolean;
  isLoading?: boolean;
  disabled?: boolean;
};

export const FormDropDown: React.FC<Props> = ({
  label,
  className,
  help,
  values = [],
  placeholder,
  isLoading = false,
  disabled = false,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);

  const actionRef = useRef<HTMLDivElement>(null);

  const handleChange = (param: any) => {
    actionRef.current && actionRef.current.blur();
    helpers.setValue(param);
  };

  return (
    <div
      className={classNames("form-dropdown", className, {
        error: meta.touched && meta.error,
      })}
    >
      <div className="d-flex justify-content-between">
        <div className="form-dropdown__label">{label}</div>
      </div>
      <div
        className="form-dropdown__container"
        ref={actionRef}
        tabIndex={disabled ? undefined : 0}
      >
        <div
          className={classNames("form-dropdown__main", {
            active: field.value,
          })}
        >
          <div className="flex-1 d-flex justify-content-between">
            <span className="my-auto">
              {field.value
                ? values.find((item) =>
                    +item.id
                      ? +item.id === +field.value
                      : item.id === field.value,
                  )?.title
                : placeholder}
            </span>
          </div>
          <FaCaretDown className="form-dropdown__arrow" />
        </div>
        <div className={classNames("form-dropdown__menu")}>
          {isLoading ? (
            <ClipLoader
              size={40}
              color="#297D4A"
              cssOverride={{
                display: "block",
                margin: "20px auto",
              }}
            />
          ) : values.length > 0 ? (
            values.map(({ title, id: itemVal }) => {
              return (
                <div
                  className={classNames("form-dropdown__menu-item", {
                    active: +field.value === +itemVal,
                  })}
                  key={itemVal}
                  onClick={() => handleChange(itemVal)}
                >
                  <span>{title}</span>
                </div>
              );
            })
          ) : (
            <div className="my-3 text-gray text-center">Empty</div>
          )}
        </div>
      </div>

      <div className="form-dropdown__footer">
        {meta.touched && meta.error && (
          <div className="form-dropdown__validation">{meta.error}</div>
        )}
        {help && <div className="form-dropdown__help ms-auto">{help}</div>}
      </div>
    </div>
  );
};
